import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfAlberta = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Alberta"
      universityShortName="U of A"
      slug="university-of-alberta"
      seoTitle="University of Alberta Study Rooms | Edmonton Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Alberta. Find Cameron Library, Rutherford Library, and noise-zoned study spaces. Plus free 24/7 online alternative."
      seoKeywords="university of alberta study rooms, ualberta library, cameron library, rutherford library, edmonton university study spaces"
      canonicalUrl="/study-room/university-of-alberta/"
      heroDescription="A comprehensive guide to study rooms and spaces at U of A, organized by noise levels across Cameron, Rutherford, and other libraries."
      libraryWebsiteUrl="https://library.ualberta.ca/"
      libraryWebsiteName="U of A Library"
      studySpaces={[
        {
          name: "Silent Study Zones",
          features: "Zones where talking and phones are forbidden for complete silence.",
          feedback: "Students appreciate clearly posted noise zones but note that enforcement can be lax."
        },
        {
          name: "Quiet Study Zones",
          features: "Zones permitting whispering and snacks for quieter collaborative work.",
          feedback: "Good balance between silence and collaboration; occasionally filled with chatty groups."
        },
        {
          name: "Discussion Zones",
          features: "Zones allowing normal conversation for group projects and discussions.",
          feedback: "Great for group work; can get noisy during peak hours."
        },
        {
          name: "Bibliothèque Saint-Jean",
          features: "Five group rooms with tables, whiteboards and LCD screens.",
          feedback: "Well-equipped for presentations; popular for group projects."
        },
        {
          name: "Cameron Library",
          features: "Discussion spaces with computers and group study rooms with displays. Features a 24-hour study hall.",
          feedback: "The 24-hour study hall is popular but group rooms require advance booking."
        },
        {
          name: "Rutherford Library",
          features: "More than 700 seats across five floors, including group rooms and study carrels.",
          feedback: "Upper floors offer silence; lower floors better for collaboration."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Choose your noise level: <strong>Rutherford's upper floors</strong> offer silence, while <strong>Cameron's main floor</strong> suits group collaboration.
          </p>
          <p className="mb-4">
            If you need technology, book a room with an LCD screen at <strong>Bibliothèque Saint-Jean</strong>. The <strong>24-hour study hall in Cameron</strong> is perfect for late-night cramming.
          </p>
          <p>
            Bring headphones for quiet zones—whispers are tolerated but ambient noise persists.
          </p>
        </>
      }
      summaryTips={[
        "Choose your noise zone: U of A clearly designates Silent, Quiet, and Discussion zones.",
        "Use Cameron's 24-hour study hall: Perfect for late-night study sessions.",
        "Book rooms with LCD screens: Bibliothèque Saint-Jean offers well-equipped group rooms.",
        "Head to Rutherford's upper floors: Over 700 seats with the quietest areas at the top.",
        "Use CSW for 24/7 access: Virtual study rooms complement the on-campus options."
      ]}
    />
  );
};

export default UniversityOfAlberta;
